import React from "react";
import logoImage from "../../images/logo.png";
const Logo = () => {
    return (
        <div className="mb-5 flex justify-center">
            <img src={logoImage} alt=""  width="130"/>
        </div>
    );
}

export default Logo;